module.exports = __webpack_public_path__ + "1c8cf37c615950217c8d216e7616e45f.png";